<template>
    <el-table :data="vastuuyksikot">
        <el-table-column label="Vastuuyksikkö" prop="nimi" />
    </el-table>
</template>

<script setup lang="ts">
import { VastuuyksikkoResponse } from "@/api/models/vastuuyksikko-response"

defineProps<{
    vastuuyksikot: VastuuyksikkoResponse[]
}>()
</script>
